import { Perfil } from "../perfil";

export enum MenuSituacao {
  ATIVO = "A",
  INATIVO = "I",
}

export enum MenuTarget {
  TRUE = "T",
  FALSE = "F",
}

export enum MenuTipo {
  PAI = "P",
  FILHO = "F",
  ÚNICO = "U",
}

export interface Menu {
  readonly id?: number | null;
  readonly nome?: string | null;
  readonly situacao?: MenuSituacao | null;
  readonly icone?: string | null;
  readonly link?: string | null;
  readonly tipo?: MenuTipo | null;
  readonly target?: MenuTarget | null;
  readonly menuPai?: Menu | null;
  readonly menusFilho?: Menu[] | null;
  readonly perfis?: Perfil[] | null;
}
